// extracted by mini-css-extract-plugin
export default {"root":"FieldCurrencyInput_root__XCHiS"};